var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useContext } from 'react';
import { RegoLookup } from '../vehicle/RegoLookup';
import { ManualLookup } from '../vehicle/ManualLookup';
import { useForm } from '../../context/FormContext';
import { createSetManualLookupDetailsAction, createSetVehicleDetailsAction, createSetEntryMethodAction, createSetRegoDetailsAction } from '../../types/form/actions';
import { VehiclesList } from '../vehicle/VehiclesList';
import { VehicleOptionsAndPacks } from '../vehicle/VehicleOptionsAndPacks';
import { SubScreenContext } from '../FormSteps';
// Function to get empty vehicle form data
var getEmptyVehicleFormData = function () { return ({
    model: '',
    badge: '',
    manufacturer: '',
    manufactureYear: '',
    badgeCategoryID: '',
    bodyType: '',
    cylinders: '',
    description: '',
    doorCount: '',
    driveType: '',
    engineSize: '',
    fuelTypeBasic: '',
    fuelTypeBasicCategoryID: '',
    imageUrl: '',
    manufacturerCategoryID: 0,
    modelCategoryID: 0,
    seatCount: 0,
    series: '',
    seriesCategoryID: 0,
    thumbUrl: '',
    transmissionTypeBasic: '',
    transmissionTypeBasicCategoryID: '',
    variantCode: '',
    entryMethod: 'rego',
    registrationNumber: '',
    registrationState: '',
    selectedOptions: [],
    selectedPacks: []
}); };
export var FindYourCar = function (_a) {
    var _b, _c, _d, _e;
    var onNext = _a.onNext;
    var _f = useForm(), state = _f.state, dispatch = _f.dispatch;
    var setCurrentSubScreen = useContext(SubScreenContext).setCurrentSubScreen;
    var savedFormData = ((_b = window.tiofSettings) === null || _b === void 0 ? void 0 : _b.savedData) || {};
    // State management
    var _g = useState(savedFormData.entry_method === 'manual'), isManualLookup = _g[0], setIsManualLookup = _g[1];
    var _h = useState([]), foundVehicles = _h[0], setFoundVehicles = _h[1];
    var _j = useState(false), showVehiclesList = _j[0], setShowVehiclesList = _j[1];
    var _k = useState(false), showOptionsAndPacks = _k[0], setShowOptionsAndPacks = _k[1];
    var _l = useState(null), selectedVehicle = _l[0], setSelectedVehicle = _l[1];
    var _m = useState(savedFormData.entry_method === 'manual' ? 'manual' : 'rego'), lastUsedLookupMethod = _m[0], setLastUsedLookupMethod = _m[1];
    // State for manual lookup form values
    var _o = useState({
        manufacturer: savedFormData.vehicle_make || savedFormData.manufacturer || '',
        year: savedFormData.vehicle_year || savedFormData.manufactureYear || '',
        model: savedFormData.vehicle_model || savedFormData.model || '',
        series: savedFormData.vehicle_series || savedFormData.series || '',
        rego: savedFormData.vehicle_rego || '',
        state: savedFormData.vehicle_state || ''
    }), manualLookupState = _o[0], setManualLookupState = _o[1];
    // Effect to restore vehicle details from saved data
    useEffect(function () {
        if (!savedFormData.vehicle_details)
            return;
        try {
            var parsedDetails = typeof savedFormData.vehicle_details === 'string'
                ? JSON.parse(savedFormData.vehicle_details.replace(/\\"/g, '"'))
                : savedFormData.vehicle_details;
            if (parsedDetails) {
                var vehicleDetails = __assign(__assign({}, parsedDetails), { entryMethod: savedFormData.entry_method || 'rego', registrationNumber: savedFormData.vehicle_rego || '', registrationState: savedFormData.vehicle_state || '', selectedOptions: [], selectedPacks: [] });
                // Update manual lookup state if it was a manual entry
                if (savedFormData.entry_method === 'manual') {
                    var newManualState = {
                        manufacturer: vehicleDetails.manufacturer || savedFormData.vehicle_make || '',
                        year: vehicleDetails.manufactureYear || savedFormData.vehicle_year || '',
                        model: vehicleDetails.model || savedFormData.vehicle_model || '',
                        series: vehicleDetails.series || savedFormData.vehicle_series || '',
                    };
                    setManualLookupState(newManualState);
                    // Also update the form context with manual lookup details
                    dispatch(createSetManualLookupDetailsAction(newManualState));
                }
                setSelectedVehicle(vehicleDetails);
                dispatch(createSetVehicleDetailsAction(vehicleDetails));
            }
        }
        catch (err) {
        }
    }, [savedFormData, dispatch]);
    // Effect to update manual lookup state when savedData changes (for session restoration)
    useEffect(function () {
        var _a;
        var currentSavedData = ((_a = window.tiofSettings) === null || _a === void 0 ? void 0 : _a.savedData) || {};
        // Update manual lookup state with the latest saved data
        var newManualState = {
            manufacturer: currentSavedData.vehicle_make || currentSavedData.manufacturer || '',
            year: currentSavedData.vehicle_year || currentSavedData.manufactureYear || '',
            model: currentSavedData.vehicle_model || currentSavedData.model || '',
            series: currentSavedData.vehicle_series || currentSavedData.series || '',
            rego: currentSavedData.vehicle_rego || '',
            state: currentSavedData.vehicle_state || ''
        };
        // Only update if there are actual values and they're different from current state
        var hasValues = newManualState.manufacturer || newManualState.year || newManualState.model || newManualState.series;
        var isDifferent = (newManualState.manufacturer !== manualLookupState.manufacturer ||
            newManualState.year !== manualLookupState.year ||
            newManualState.model !== manualLookupState.model ||
            newManualState.series !== manualLookupState.series ||
            newManualState.rego !== manualLookupState.rego ||
            newManualState.state !== manualLookupState.state);
        if (hasValues && isDifferent) {
            setManualLookupState(newManualState);
        }
    }, [(_c = window.tiofSettings) === null || _c === void 0 ? void 0 : _c.savedData, manualLookupState]);
    // Handle vehicles found from either lookup method
    var handleVehiclesFound = function (vehicles, method) {
        if (method === void 0) { method = 'rego'; }
        setLastUsedLookupMethod(method);
        setFoundVehicles(vehicles);
        setShowVehiclesList(true);
        setShowOptionsAndPacks(false);
        // If it's manual lookup, ensure the form context is updated
        if (method === 'manual') {
            dispatch(createSetManualLookupDetailsAction(manualLookupState));
        }
    };
    // Handle vehicle selection from list
    var handleVehicleSelect = function (vehicle) {
        var _a, _b;
        var vehicleFormData = __assign(__assign({}, vehicle), { entryMethod: lastUsedLookupMethod, registrationNumber: ((_a = state.regoDetails) === null || _a === void 0 ? void 0 : _a.rego) || '', registrationState: ((_b = state.regoDetails) === null || _b === void 0 ? void 0 : _b.state) || '', selectedOptions: [], selectedPacks: [] });
        setSelectedVehicle(vehicleFormData);
        // Set the entry method
        dispatch(createSetEntryMethodAction(lastUsedLookupMethod));
        // Set the vehicle details
        dispatch(createSetVehicleDetailsAction(vehicleFormData));
        // If it's manual lookup, update the manual lookup details
        if (lastUsedLookupMethod === 'manual' && manualLookupState) {
            dispatch(createSetManualLookupDetailsAction(manualLookupState));
        }
        setShowVehiclesList(false);
        setShowOptionsAndPacks(true);
    };
    // Handle options and packs selection
    var handleOptionsAndPacksComplete = function (vehicle, selectedOptions, selectedPacks) {
        var _a, _b;
        var enhancedVehicle = __assign(__assign({}, vehicle), { entryMethod: lastUsedLookupMethod, registrationNumber: ((_a = state.regoDetails) === null || _a === void 0 ? void 0 : _a.rego) || '', registrationState: ((_b = state.regoDetails) === null || _b === void 0 ? void 0 : _b.state) || '', selectedOptions: selectedOptions ? selectedOptions.split(',').map(function (o) { return o.trim(); }) : [], selectedPacks: selectedPacks ? selectedPacks.split(',').map(function (p) { return p.trim(); }) : [] });
        dispatch(createSetVehicleDetailsAction(enhancedVehicle));
        onNext();
    };
    // Handle manual lookup form changes
    var handleManualLookupChange = function (values) {
        // Update local state
        setManualLookupState(function (prev) {
            var _a, _b;
            var newState = __assign(__assign({}, prev), values);
            // Update form context
            dispatch(createSetManualLookupDetailsAction(newState));
            // If optional rego/state provided, sync into regoDetails context
            if (typeof values.rego !== 'undefined' || typeof values.state !== 'undefined') {
                var currentRego = typeof values.rego !== 'undefined' ? values.rego : (((_a = state.regoDetails) === null || _a === void 0 ? void 0 : _a.rego) || '');
                var currentState = typeof values.state !== 'undefined' ? values.state : (((_b = state.regoDetails) === null || _b === void 0 ? void 0 : _b.state) || '');
                dispatch(createSetRegoDetailsAction(__assign(__assign({}, state.regoDetails), { rego: currentRego || '', state: currentState || '' })));
            }
            return newState;
        });
    };
    // Navigation handlers
    var handleBackToSearch = function () {
        setShowVehiclesList(false);
        setShowOptionsAndPacks(false);
        // If we're coming back from manual lookup, ensure we keep the last used values
        if (lastUsedLookupMethod === 'manual') {
            setIsManualLookup(true);
            // No need to update manualLookupState as it's already preserved
        }
    };
    var handleBackFromOptionsAndPacks = function () {
        setShowOptionsAndPacks(false);
        setShowVehiclesList(true);
    };
    var toggleLookupMethod = function () {
        setIsManualLookup(!isManualLookup);
        setShowVehiclesList(false);
        setShowOptionsAndPacks(false);
    };
    var handleReturnToRegoLookup = function () {
        setIsManualLookup(false);
        setShowVehiclesList(false);
        setShowOptionsAndPacks(false);
        setSelectedVehicle(null);
        dispatch(createSetVehicleDetailsAction(getEmptyVehicleFormData()));
    };
    // Update sub-screen when screen changes
    useEffect(function () {
        if (showVehiclesList) {
            setCurrentSubScreen('vehiclesList');
        }
        else if (showOptionsAndPacks) {
            setCurrentSubScreen('optionsAndPacks');
        }
        else if (isManualLookup) {
            setCurrentSubScreen('manualLookup');
        }
        else {
            setCurrentSubScreen('regoLookup');
        }
    }, [showVehiclesList, showOptionsAndPacks, isManualLookup, setCurrentSubScreen]);
    return (_jsx("div", { className: "find-your-car", children: showOptionsAndPacks && selectedVehicle ? (_jsx(VehicleOptionsAndPacks, { selectedVehicle: selectedVehicle, onNextStep: handleOptionsAndPacksComplete, onBack: handleBackFromOptionsAndPacks, onRegoLookup: handleReturnToRegoLookup })) : showVehiclesList ? (_jsx(VehiclesList, { vehicles: foundVehicles, onVehicleSelect: handleVehicleSelect, onBack: handleBackToSearch })) : isManualLookup ? (_jsx(ManualLookup, { onRegoLookup: toggleLookupMethod, onVehiclesFound: function (vehicles) { return handleVehiclesFound(vehicles, 'manual'); }, initialValues: manualLookupState, onChange: handleManualLookupChange })) : (_jsx(RegoLookup, { onVehiclesFound: function (vehicles) { return handleVehiclesFound(vehicles, 'rego'); }, savedData: {
                rego: ((_d = state.regoDetails) === null || _d === void 0 ? void 0 : _d.rego) || '',
                state: ((_e = state.regoDetails) === null || _e === void 0 ? void 0 : _e.state) || ''
            }, onShowManualLookup: toggleLookupMethod })) }));
};
